/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Employee } from '../../models/employee';
import { UpdateEmployeeRequest } from '../../models/update-employee-request';

export interface UpdateEmployee$Params {
  organizationId: string;
  employeeId: string;
  
    /**
     * Employee to be updated.
     */
    body: UpdateEmployeeRequest
}

export function updateEmployee(http: HttpClient, rootUrl: string, params: UpdateEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<Employee>> {
  const rb = new RequestBuilder(rootUrl, updateEmployee.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('employeeId', params.employeeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Employee>;
    })
  );
}

updateEmployee.PATH = '/v1/organizations/{organizationId}/configuration/integration/employees/{employeeId}';
